// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  vouchId: __t.u64().primaryKey().name("vouch_id"),
  voucher: __t.identity(),
  vouchee: __t.identity(),
  infStaked: __t.i64().name("inf_staked"),
  weightX100: __t.i32().name("weight_x_100"),
  at: __t.timestamp(),
  active: __t.bool(),
});
